(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- Header: solid-on-scroll + logo swap ---------------- */
  function initHeader() {
    var header = document.querySelector('.fq-header');
    if (!header) return;
    var logo = header.querySelector('img.fq-logo');
    function update() {
      var solid = window.scrollY > 4 || !header.classList.contains('fq-dark');
      header.classList.toggle('fq-solid', solid);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();

    var menuBtn = document.querySelector('.fq-menu-btn');
    var mobileMenu = document.querySelector('.fq-mobile-menu');
    if (menuBtn && mobileMenu) {
      menuBtn.addEventListener('click', function () {
        mobileMenu.classList.toggle('fq-open');
      });
      Array.prototype.forEach.call(mobileMenu.querySelectorAll('a, [data-fq-wishlist-toggle]'), function (a) {
        a.addEventListener('click', function () { mobileMenu.classList.remove('fq-open'); });
      });
      var closeBtn = mobileMenu.querySelector('.fq-mobile-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { mobileMenu.classList.remove('fq-open'); });
    }
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-fq-reveal]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fq-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---------------- Horizontal scent scroller + progress bar ---------------- */
  function initScrollers() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fq-scroller]'), function (scroller) {
      var id = scroller.getAttribute('data-fq-scroller');
      var thumb = document.querySelector('[data-fq-thumb="' + id + '"]');
      if (!thumb) return;
      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        var ratio = max > 0 ? scroller.scrollLeft / max : 0;
        var t = Math.min(1, scroller.clientWidth / scroller.scrollWidth);
        thumb.style.width = (t * 100) + '%';
        thumb.style.left = (ratio * (100 - t * 100)) + '%';
      }
      update();
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  /* ---------------- Format picker + add to cart (fragrance collection page) ---------------- */
  function initFormatPicker() {
    var root = document.querySelector('[data-fq-format-picker]');
    if (!root) return;
    var pills = root.querySelectorAll('.fq-fmt-pill');
    var photo = document.querySelector('[data-fq-selected-photo]');
    var amount = document.querySelector('[data-fq-selected-price]');
    var buyBtn = document.querySelector('[data-fq-buy-btn]');

    function select(pill) {
      Array.prototype.forEach.call(pills, function (p) { p.classList.remove('fq-active'); });
      pill.classList.add('fq-active');
      var img = pill.getAttribute('data-image');
      var price = pill.getAttribute('data-price');
      var variantId = pill.getAttribute('data-variant-id');
      var available = pill.getAttribute('data-available') === 'true';
      if (photo && img) photo.setAttribute('src', img);
      if (amount && price) amount.textContent = price;
      if (buyBtn) {
        buyBtn.setAttribute('data-variant-id', variantId);
        buyBtn.disabled = !available;
        buyBtn.textContent = available ? buyBtn.getAttribute('data-label-available') : buyBtn.getAttribute('data-label-unavailable');
      }
    }

    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () { select(pill); });
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var variantId = buyBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        buyBtn.disabled = true;
        var originalText = buyBtn.textContent;
        buyBtn.textContent = 'Adding…';
        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = window.routes.cart_url;
          })
          .catch(function () {
            buyBtn.disabled = false;
            buyBtn.textContent = originalText;
          });
      });
    }
  }

  /* ---------------- Testimonials: continuously auto-rotating marquee, pauses on hover/touch ----------------
     The motion itself is a pure CSS animation (see .fq-marquee-track in fq-theme.css) so it runs on the
     compositor thread identically in every browser. Hover-to-pause is plain CSS (:hover). The only JS needed
     is toggling a class for touch, since touch devices don't have a reliable hover state. */
  function initTestimonialsMarquee() {
    var marquee = document.querySelector('[data-fq-marquee="testimonials"]');
    if (!marquee) return;
    marquee.addEventListener('touchstart', function () { marquee.classList.add('fq-touch-paused'); }, { passive: true });
    marquee.addEventListener('touchend', function () { marquee.classList.remove('fq-touch-paused'); }, { passive: true });
    marquee.addEventListener('touchcancel', function () { marquee.classList.remove('fq-touch-paused'); }, { passive: true });
  }

  /* ---------------- Shop page: client-side category filter ---------------- */
  function initShopPage() {
    var pillsWrap = document.querySelector('[data-fq-shop-pills]');
    if (!pillsWrap) return;
    var pills = pillsWrap.querySelectorAll('[data-fq-shop-pill]');
    var panels = document.querySelectorAll('[data-fq-shop-panel]');

    function activate(handle) {
      Array.prototype.forEach.call(pills, function (p) {
        p.classList.toggle('fq-active', p.getAttribute('data-fq-shop-pill') === handle);
      });
      Array.prototype.forEach.call(panels, function (panel) {
        panel.hidden = panel.getAttribute('data-fq-shop-panel') !== handle;
      });
    }

    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        activate(pill.getAttribute('data-fq-shop-pill'));
      });
    });

    var params = new URLSearchParams(window.location.search);
    var catsParam = params.get('cats');
    var wanted = params.get('cat');

    if (catsParam) {
      var allowed = catsParam.split(',').map(function (h) { return h.trim(); });
      var firstVisible = null;
      Array.prototype.forEach.call(pills, function (p) {
        var h = p.getAttribute('data-fq-shop-pill');
        var show = allowed.indexOf(h) !== -1;
        p.hidden = !show;
        if (show && !firstVisible) firstVisible = h;
      });
      if (firstVisible) activate(firstVisible);
      var browseAll = document.querySelector('[data-fq-shop-browse-all]');
      if (browseAll) browseAll.hidden = false;
    } else if (wanted && pillsWrap.querySelector('[data-fq-shop-pill="' + wanted + '"]')) {
      activate(wanted);
    }
  }

  /* ---------------- Wishlist: localStorage-backed, no app/account required ---------------- */
  function initWishlist() {
    var KEY = 'fq_wishlist';

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function write(items) {
      localStorage.setItem(KEY, JSON.stringify(items));
    }
    function indexOfHandle(items, handle) {
      for (var i = 0; i < items.length; i++) { if (items[i].handle === handle) return i; }
      return -1;
    }

    function updateCount() {
      var items = read();
      Array.prototype.forEach.call(document.querySelectorAll('[data-fq-wishlist-count]'), function (badge) {
        badge.textContent = items.length;
        badge.hidden = items.length === 0;
      });
    }

    function updateHearts() {
      var items = read();
      Array.prototype.forEach.call(document.querySelectorAll('[data-fq-heart]'), function (heart) {
        heart.classList.toggle('fq-active', indexOfHandle(items, heart.getAttribute('data-fq-heart')) !== -1);
      });
    }

    function renderPanel() {
      var container = document.querySelector('[data-fq-wishlist-items]');
      if (!container) return;
      var items = read();
      if (!items.length) {
        container.innerHTML = '<p style="font-size:14px;color:rgba(29,29,31,.55);padding:24px 0;">Nothing saved yet. Tap the heart on any product to add it here.</p>';
        return;
      }
      container.innerHTML = items.map(function (item, i) {
        return '<div style="display:flex;gap:12px;align-items:center;padding:12px 0;border-bottom:1px solid rgba(29,29,31,.08);">' +
          '<a href="' + item.url + '" style="flex-shrink:0;"><img src="' + item.image + '" alt="" style="width:56px;height:56px;object-fit:cover;border-radius:10px;"></a>' +
          '<div style="flex:1;min-width:0;"><a href="' + item.url + '" style="font-size:13px;font-weight:500;display:block;color:#1d1d1f;">' + item.title + '</a><span style="font-size:12px;color:rgba(29,29,31,.5);">' + item.price + '</span></div>' +
          '<button type="button" data-fq-wishlist-remove="' + i + '" aria-label="Remove" style="width:24px;height:24px;flex-shrink:0;font-size:18px;line-height:1;color:rgba(29,29,31,.4);">×</button>' +
          '</div>';
      }).join('');

      Array.prototype.forEach.call(container.querySelectorAll('[data-fq-wishlist-remove]'), function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-fq-wishlist-remove'), 10);
          var items = read();
          items.splice(idx, 1);
          write(items);
          updateCount();
          renderPanel();
          updateHearts();
        });
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-fq-heart]'), function (heart) {
      heart.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = heart.getAttribute('data-fq-heart');
        var items = read();
        var idx = indexOfHandle(items, handle);
        if (idx > -1) {
          items.splice(idx, 1);
        } else {
          items.push({
            handle: handle,
            title: heart.getAttribute('data-fq-heart-title'),
            price: heart.getAttribute('data-fq-heart-price'),
            image: heart.getAttribute('data-fq-heart-image'),
            url: heart.getAttribute('data-fq-heart-url')
          });
        }
        write(items);
        updateCount();
        renderPanel();
        updateHearts();
      });
    });

    var panel = document.querySelector('[data-fq-wishlist-panel]');
    var closeBtn = document.querySelector('[data-fq-wishlist-close]');
    if (panel) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fq-wishlist-toggle]'), function (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          panel.classList.add('fq-open');
          renderPanel();
        });
      });
    }
    if (closeBtn && panel) {
      closeBtn.addEventListener('click', function () { panel.classList.remove('fq-open'); });
    }

    updateCount();
    updateHearts();
  }

  ready(function () {
    initHeader();
    initReveal();
    initScrollers();
    initFormatPicker();
    initShopPage();
    initWishlist();
    initTestimonialsMarquee();
  });
})();
